import {IconHWColorProps} from "./types";

export default function MoreIcon({
    width="11",
    height="3",
    color="black",
    ...props
                                 }:IconHWColorProps) {
    return <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 11 3" fill="none" {...props}>
        <path
            d="M2.3335 1.33325C2.3335 1.88554 1.88578 2.33325 1.3335 2.33325C0.781211 2.33325 0.333496 1.88554 0.333496 1.33325C0.333496 0.780967 0.781211 0.333252 1.3335 0.333252C1.88578 0.333252 2.3335 0.780967 2.3335 1.33325Z"
            fill={color}/>
        <path
            d="M6.3335 1.33325C6.3335 1.88554 5.88578 2.33325 5.3335 2.33325C4.78121 2.33325 4.3335 1.88554 4.3335 1.33325C4.3335 0.780967 4.78121 0.333252 5.3335 0.333252C5.88578 0.333252 6.3335 0.780967 6.3335 1.33325Z"
            fill={color}/>
        <path
            d="M10.3335 1.33325C10.3335 1.88554 9.88578 2.33325 9.3335 2.33325C8.78121 2.33325 8.3335 1.88554 8.3335 1.33325C8.3335 0.780967 8.78121 0.333252 9.3335 0.333252C9.88578 0.333252 10.3335 0.780967 10.3335 1.33325Z"
            fill={color}/>
    </svg>
}